import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const deleteModalDrivingSchoolsSlice = createSlice({
  name: "deleteModalDrivingSchools",
  initialState,
  reducers: {
    openModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModalDelete: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModalDelete, closeModalDelete } = deleteModalDrivingSchoolsSlice.actions;
export default deleteModalDrivingSchoolsSlice.reducer;
